var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.value !== null && _vm.value !== '')?_c('span',[_vm._v(_vm._s(_vm._f("format")(_vm.value,'L')))]):_c('span',[_vm._v(" - ")])])}
var staticRenderFns = []

export { render, staticRenderFns }